import { useState, useCallback } from "react";

// Custom hook for managing multiple category navigation states
const useCategoryNavigation = (categoriesData) => {
  // Initialize state for all categories
  const [categoryIndices, setCategoryIndices] = useState(() => {
    const initialState = {};
    Object.keys(categoriesData).forEach((category) => {
      initialState[category] = 0;
    });
    return initialState;
  });

  // Generic handler creator
  const createNavigationHandlers = useCallback(
    (categoryKey) => {
      const articles = categoriesData[categoryKey] || [];

      const handlePrevious = () => {
        const articlesPerPage = window.innerWidth < 768 ? 1 : 3;
        setCategoryIndices((prev) => ({
          ...prev,
          [categoryKey]: Math.max(0, prev[categoryKey] - articlesPerPage),
        }));
      };

      const handleNext = () => {
        const articlesPerPage = window.innerWidth < 768 ? 1 : 3;
        const maxIndex = Math.max(0, articles.length - articlesPerPage);
        setCategoryIndices((prev) => ({
          ...prev,
          [categoryKey]: Math.min(
            maxIndex,
            prev[categoryKey] + articlesPerPage,
          ),
        }));
      };

      return { handlePrevious, handleNext };
    },
    [categoriesData],
  );

  // Get navigation handlers for all categories
  const getNavigationHandlers = useCallback(() => {
    const handlers = {};
    Object.keys(categoriesData).forEach((categoryKey) => {
      handlers[categoryKey] = createNavigationHandlers(categoryKey);
    });
    return handlers;
  }, [categoriesData, createNavigationHandlers]);

  // Get current index for a specific category
  const getCurrentIndex = useCallback(
    (categoryKey) => {
      return categoryIndices[categoryKey] || 0;
    },
    [categoryIndices],
  );

  return {
    categoryIndices,
    getCurrentIndex,
    getNavigationHandlers,
    createNavigationHandlers,
  };
};

export default useCategoryNavigation;
